import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

const parseStringArray = val => {
  if (val === undefined || val === null) return [];
  try {
    // If it's already an array, return as-is (assume elements are strings)
    if (Array.isArray(val)) return val;
    // If it's a string, try to parse JSON
    if (typeof val === 'string') {
      const parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed : [];
    }
    return [];
  } catch (e) {
    // On parse error, return empty array to avoid crashing the UI
    return [];
  }
};

const toDropdownOptions = (arr, ruleId) => arr.map(v => ({
  key: String(v),
  text: String(v),
  value: v,
  'data-testid': `multiselect-option-${ruleId}-${String(v)}`,
}));

const MultiselectValue = ({ rule, onValueChange, disabled }) => {
  const optionValues = parseStringArray(rule.options);
  const selectedValues = parseStringArray(rule.value);

  const options = toDropdownOptions(optionValues, rule.id);

  return (
    <Dropdown
      multiple
      selection
      options={options}
      value={selectedValues}
      onChange={(e, data) => onValueChange(rule.instanceId, JSON.stringify(data.value))}
      placeholder='Select options...'
      disabled={disabled}
      data-testid={`multiselect-${rule.id}`}
      icon={(
        <i
          className='dropdown icon'
          data-testid={`multiselect-toggle-${rule.id}`}
        />
      )}
      renderLabel={item => ({
        content: item.text,
        'data-testid': `multiselect-chip-${rule.id}-${String(item.value)}`,
        removeIcon: (
          <i
            className='delete icon'
            data-testid={`multiselect-chip-delete-${rule.id}-${String(item.value)}`}
          />
        ),
      })}
    />
  );
};

MultiselectValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default MultiselectValue;
